import React from "react";
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../utils/Loader";
import { userManualDownloadUrl, disclaimer } from "../utils/constants";
import Modal from "react-modal";
import moment from "moment";
import StepHeader from "../screens/registration/stepHeader";
import VendorModule from "../screens/vendor_module/vendor_module";
import TabComponent from "./TabComponent";
import AdminDrawer from "./admin_module_drawer.js";
import AdminMobileDrawer from "./admin_module_mobile_drawer.js";

Modal.setAppElement("#root");

const HeaderWithLogo = () => {
  const history = useNavigate();
  const navigate = useNavigate();
  const [isLoading, setLoader] = useState(false);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobileMenuOpen2, setMobileMenuOpen2] = useState(false);
  const marqueeRef = useRef(null);
  const loadScripts = () => {
    // Your existing script loading logic
  };

  useEffect(() => {
    loadScripts();
    console.log(
      "Exhibition Logo---------------------->",
      sessionStorage.getItem("ExhibitionLogoSS")
    );
  }, []);

  const onLogoutClick = () => {
    localStorage.clear();
    navigate("/");
  };

  const openPdf = () => {
    var URL = userManualDownloadUrl;
    window.open(URL, null);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleMobileMenu2 = () => {
    setMobileMenuOpen2(!isMobileMenuOpen2);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const closeMobileMenu2 = () => {
    setMobileMenuOpen2(false);
  };

  // Exhibition From Date
  const dateString = sessionStorage.getItem("exhibitionDateFrom");
  const dateStringMoment = moment
    .utc(dateString, "DD/MM/YYYY")
    .format("DD MMMM YYYY");
  const dateObject = new Date(dateStringMoment);
  const fromDay = dateObject.getDate();
  const fromMonth = dateObject.toLocaleString("default", { month: "long" });
  const fromYear = dateObject.getFullYear();
  const fromDate = `${fromDay} ${fromMonth} ${fromYear}`;

  // Exhibition to Date
  const dateString1 = sessionStorage.getItem("exhibitionDateTo");
  const dateString1Moment = moment
    .utc(dateString1, "DD/MM/YYYY")
    .format("DD MMMM YYYY");
  const dateObject1 = new Date(dateString1Moment);
  const toDay = dateObject1.getDate();
  const toMonth = dateObject1.toLocaleString("default", { month: "long" });
  const toYear = dateObject1.getFullYear();
  const toDate = `${toDay} ${toMonth} ${toYear}`;

  // Exhibition Address
  const address = sessionStorage.getItem("ExhibitionAddressSS");

  // Logo URLs
  const exhibitionLogo = sessionStorage.getItem("ExhibitionLogoSS");
  const mainLogo = sessionStorage.getItem("MainLogoSS") || "../images/Logo_3.png";

  // Exhibition Dates
  const exhibitionFromDate = sessionStorage.getItem("ExhibitionFromDateSS");
  const exhibitionToDate = sessionStorage.getItem("ExhibitionToDateSS");

  // Profile and User Details
  const profileName = sessionStorage.getItem("profileNameSS");
  const roleID = sessionStorage.getItem("RoleIDSS");

  // Corporate Link
  const corporateLink = sessionStorage.getItem("CorporateLinkSS") || "https://corporate.india-itme.com";


  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);

      // ✅ Force-close mobile menus when switching to desktop
      if (!mobile) {
        setMobileMenuOpen(false);
        setMobileMenuOpen2(false);
      }
    };

    window.addEventListener("resize", handleResize);

    // Run once on mount to sync state
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return (
    <>
      {isLoading ? <Loader></Loader> : null}

      {isMobileMenuOpen && (
        <div
          className="mobile-menu-overlay exhibitor-mobile-overlay"
          onClick={closeMobileMenu}
        ></div>
      )}

      {/* Mobile Sidebar Menu */}
      <div
        className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen ? "mobile-menu-open" : ""
          }`}
      >
        <div className="mobile-menu-header exhibitor-menu-header">
          <button
            onClick={closeMobileMenu}
            className="exhibitor-menu-close-btn text-white"
          >
            ×
          </button>
          <div className="user-info exhibitor-user-info">
            <h5 className=" text-white mb-0">Welcome,</h5>
            <h4 className="text-uppercase fw-semibold text-white fw-bold">
              {profileName}
            </h4>
            {/* <div className="exhibitor-user-role">Exhibitor Dashboard</div> */}
          </div>
        </div>

        <div className="mobile-menu-content exhibitor-menu-content">
          <div className="menu-section exhibitor-details-section">
            <h6 className="exhibitor-section-title">Exhibition Details</h6>
            <p className="exhibitor-detail-text">
              {exhibitionFromDate} - {exhibitionToDate}
            </p>
            <p className="exhibitor-detail-address">{address}</p>
          </div>

          <div className="menu-section exhibitor-links-section">
            <h6 className="exhibitor-section-title gap-1">Quick Links</h6>
            <a
              href={corporateLink}
              target="_blank"
              rel="noopener noreferrer"
              className="exhibitor-menu-link mb-2 mobi"
              onClick={closeMobileMenu}
            >
              For new corporate site please <span className="text-primary ms-1"> Click here</span>
            </a>

          </div>

          <div className="menu-section exhibitor-account-section">
            {/* <h6 className="exhibitor-section-title">Exhibitor Account</h6> */}
            <Link
              to={"/Change_Password"}
              className="exhibitor-menu-link mb-2"
              onClick={closeMobileMenu}
            >
              <i
                className="fa fa-cog exhibitor-menu-icon "
                aria-hidden="true"
              ></i>
              Change Password
            </Link>
            <button
              onClick={() => {
                closeMobileMenu();
                onLogoutClick();
              }}
              className="exhibitor-menu-link exhibitor-logout-btn"
            >
              <i
                className="fa fa-sign-out exhibitor-menu-icon"
                aria-hidden="true"
              ></i>
              Sign out
            </button>
          </div>

          {/* Exhibitor Specific Links */}
          {/* <div className="menu-section exhibitor-specific-section">
                        <h6 className="exhibitor-section-title">
                            Exhibitor Tools
                        </h6>
                        <Link 
                            to={'/exhibitor/dashboard'} 
                            className="exhibitor-menu-link"
                            onClick={closeMobileMenu}
                        >
                            <i className="fa fa-dashboard exhibitor-menu-icon" aria-hidden="true"></i>
                            Dashboard
                        </Link>
                        <Link 
                            to={'/exhibitor/profile'} 
                            className="exhibitor-menu-link"
                            onClick={closeMobileMenu}
                        >
                            <i className="fa fa-user exhibitor-menu-icon" aria-hidden="true"></i>
                            Profile Management
                        </Link>
                        <Link 
                            to={'/exhibitor/bookings'} 
                            className="exhibitor-menu-link"
                            onClick={closeMobileMenu}
                        >
                            <i className="fa fa-calendar exhibitor-menu-icon" aria-hidden="true"></i>
                            My Bookings
                        </Link>
                    </div> */}
        </div>
      </div>

      {isMobileMenuOpen2 && (
        <div
          className="mobile-menu-overlay exhibitor-mobile-overlay"
          onClick={closeMobileMenu2}
        ></div>
      )}

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen2 && (
        <>

          {/* Mobile Tabs Sidebar */}
          <div className={`mobile-sidebar-menu exhibitor-mobile-menu ${isMobileMenuOpen2 ? "mobile-menu-open" : ""
            }`}>
            <div className="mobile-menu-header exhibitor-menu-header">
              <button
                onClick={closeMobileMenu2}
                className="exhibitor-menu-close-btn text-white"
              >
                ×
              </button>
              <h5 className="text-white mb-0">Menu
                <AdminMobileDrawer />
              </h5>

            </div>

            {/* <TabComponent
              tabs={MOBILE_TABS}
              activeTab={activeTab}
              onTabChange={(tab) => {
                handleTabChange(tab);
                closeMobileMenu2();
              }}
              onSpecialClick={() => {
                closeMobileMenu2();
              }}
              isMobile
            /> */}
          </div>
        </>
      )}

      {/* app-Header */}
      <div className="app-header header sticky app-heder-with-logo mb-4 exhibitor-header">
        <div className="container-fluid main-container">
          <div className="header-content-wrapper exhibitor-header-wrapper">
            {/* Logo Section */}
            <div
              className="side-header top-logo-almnt"
            >
              <a className="header-brand1" href="index.html">
                {exhibitionLogo && (
                  <img
                    src={exhibitionLogo}
                    className="header-brand-img light-logo"
                    alt="logo"
                    style={{ width: "40px" }}
                  />
                )}
                {mainLogo && (
                  <img
                    src={mainLogo}
                    className="header-brand-img"
                    alt="main logo"
                  />
                )}
              </a>
              {/* LOGO */}
            </div>

            {/* Left Aligned Exhibition Details and Corporate Link */}
            <div className="exhibitor-content-left">
              {/* Exhibition Dates and Address */}
              <div className="exhibitor-event-info">
                <h5 className="exhibitor-event-dates">
                  {exhibitionFromDate} - {exhibitionToDate}
                </h5>
                <p className="exhibitor-event-address">{address}</p>
              </div>

              {/* Corporate Link */}
              <div className="exhibitor-corporate-info"></div>
            </div>

            {/* Desktop Profile - Hidden on mobile */}
            <div className="desktop-profile exhibitor-desktop-profile d-none d-lg-block">
              <div className="dropdown profile-1 exhibitor-profile-dropdown d-flex">
                <h6 className=" mt-2 mx-4 text-white">
                  <a
                    href={corporateLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="exhibitor-corporate-anchor desk"
                  >
                    For new corporate site please <span>Click here</span>
                  </a>
                </h6>
                <a
                  href="javascript:void(0)"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  className="exhibitor-profile-trigger"
                >
                  <span className="user-in exhibitor-profile-name">
                    {/* <i className="fa fa-user-circle exhibitor-profile-icon" aria-hidden="true"></i> */}
                    {profileName}
                  </span>
                </a>
                <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow exhibitor-dropdown-menu">
                  <div className="exhibitor-dropdown-header">
                    <div className="exhibitor-dropdown-user">
                      {profileName}
                    </div>
                    {/* <div className="exhibitor-dropdown-role">
                                            Exhibitor
                                        </div> */}
                  </div>
                  <div className="exhibitor-dropdown-divider"></div>
                  {/* <Link to={'/exhibitor/dashboard'} className="dropdown-item exhibitor-dropdown-item">
                                        <i className="fa fa-dashboard exhibitor-dropdown-icon" aria-hidden="true"></i>
                                        Dashboard
                                    </Link>
                                    <Link to={'/exhibitor/profile'} className="dropdown-item exhibitor-dropdown-item">
                                        <i className="fa fa-user exhibitor-dropdown-icon" aria-hidden="true"></i>
                                        Profile
                                    </Link> */}
                  <Link
                    to={"/Change_Password"}
                    className="dropdown-item exhibitor-dropdown-item"
                  >
                    <i
                      className="fa fa-cog exhibitor-dropdown-icon"
                      aria-hidden="true"
                    ></i>
                    Change Password
                  </Link>
                  {/* <a className="dropdown-item exhibitor-dropdown-item" onClick={openPdf}>
                                        <i className="fa fa-download exhibitor-dropdown-icon" aria-hidden="true"></i>
                                        User Manual
                                    </a> */}
                  <div className="exhibitor-dropdown-divider"></div>
                  <a
                    className="dropdown-item exhibitor-dropdown-item exhibitor-logout-item"
                    onClick={() => onLogoutClick()}
                  >
                    <i
                      className="fa fa-sign-out exhibitor-dropdown-icon"
                      aria-hidden="true"
                    ></i>
                    Sign out
                  </a>
                </div>
              </div>
            </div>

            {/* Mobile Toggle Button - Visible only on mobile */}
            <div className="mobile-toggle exhibitor-mobile-toggle d-lg-none">
              <button
                onClick={toggleMobileMenu}
                className="exhibitor-menu-toggle-btn admin-details text-white" style={{ padding: '3px 7px' }}>
                {/* <span className="exhibitor-menu-toggle-bar"></span>
                <span className="exhibitor-menu-toggle-bar"></span>
                <span className="exhibitor-menu-toggle-bar"></span> */}
                <span class="material-symbols-outlined">
                  person
                </span>
              </button>
            </div>
            {(roleID == 2 || roleID == 5 || roleID == 6) &&
              <div className="mobile-toggle exhibitor-mobile-toggle d-lg-none">
                <button
                  onClick={toggleMobileMenu2}
                  className="exhibitor-menu-toggle-btn"
                >
                  <span className="exhibitor-menu-toggle-bar"></span>
                  <span className="exhibitor-menu-toggle-bar"></span>
                  <span className="exhibitor-menu-toggle-bar"></span>
                </button>
              </div>
            }
          </div>
          <div className="marquee-text">
            <marquee
              behavior="scroll"
              direction="left"
              scrollamount="5"
              ref={marqueeRef}
              onMouseOver={() => marqueeRef.current?.stop()}
              onMouseOut={() => marqueeRef.current?.start()}
            >
              <b>Disclaimer and Ownership:</b> {disclaimer}
            </marquee>
          </div>
        </div>
      </div>
      {/* /app-Header */}
    </>
  );
};

export default HeaderWithLogo;
